import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dock } from '../../../components/common'
import { getText } from '../../../internal/TextLabels'
import { ChatHistory } from './ChatHistory'
import { ChatEdit } from './ChatEdit'
import { ChatStatus } from './ChatStatus'
import cssStyles from '../chat.module.scss'

export const ChatEditor = ({
  title,
  defaultText,
  statusText,
  buttonText,
  penState,
  history,
  onBeforeCloseChat,
  ...props
}) => {
  const [message, setMessage] = useState(defaultText)

  const onSend = msg => {
    props.onSend(msg)
    setMessage('')
  }

  const chatHistory = [...history]
  if (penState) {
    chatHistory.push({ text: '...', fromMe: false, isPenState: true })
  }
  return (
    <Dock
      title={title}
      closeText={getText('default.close')}
      onBack={props.onClose}
      onMinimize={props.onMinimize}
      dockClass={cssStyles.dock}
      onBeforeCloseChat={onBeforeCloseChat}
    >
      <div>
        <ChatStatus statusText={statusText} />
        <ChatHistory history={chatHistory} />
        <ChatEdit
          currentText={message}
          buttonText={buttonText}
          onSend={onSend}
          onChange={setMessage}
          requestTypeValid
        />
      </div>
    </Dock>
  )
}

ChatEditor.propTypes = {
  title: PropTypes.string.isRequired,
  statusText: PropTypes.string,
  defaultText: PropTypes.string,
  history: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
  penState: PropTypes.bool.isRequired,
  onBeforeCloseChat: PropTypes.func.isRequired,
}

ChatEditor.defaultProps = {
  defaultText: null,
  statusText: null,
}
